module.exports = __webpack_public_path__ + "img/jingle-bells-image.0371a826.jpg";